import React from "react";
import { classNames } from "../../shared/utility";
import { InputNumber } from "primereact/inputnumber";
import type { InputNumberProps, InputNumberValueChangeEvent } from "primereact/inputnumber";
import type { NumericInputChangeEvent } from "./InputNumberOnly";

interface DollarInputTextProps extends Omit<InputNumberProps, "onChange" | "onValueChange" | "value" | "mode" | "currency" | "locale"> {
  parentClass?: string;
  label?: React.ReactNode;
  value?: number | null;
  labelOn?: boolean;
  error?: string;
  explanation?: React.ReactNode;
  labelClass?: string;
  onChange?: (event: NumericInputChangeEvent) => void;
}

export default function DollarInputText(props: DollarInputTextProps) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    value,
    labelOn,
    error,
    suffix,
    explanation,
    labelClass,
    ...other
  } = props;

  // PrimeReact InputNumber uses onValueChange({ value }) — useForm expects e.target.name/value
  const handleValueChange = (e: InputNumberValueChangeEvent) => {
    if (!onChange) return;
    const raw = e?.value;
    onChange({
      target: {
        name: name ?? "",
        value: raw === null || raw === undefined ? "" : raw,
      },
    });
  };

  return (
    <div className={parentClass || undefined}>
      {labelOn ? (
        <label
          htmlFor={name}
          className={classNames(
            labelClass ? labelClass : "text-sm",
            "block font-medium text-gray-900 mb-2"
          )}
        >
          {label}
        </label>
      ) : null}
      <div>
        <InputNumber
          name={name}
          className={classNames(className, "w-full")}
          value={value}
          onValueChange={handleValueChange}
          mode="currency"
          currency="USD"
          locale="en-US"
          onKeyDown={(e) => e.stopPropagation()}
          suffix={suffix}
          {...other}
        />

        {error ? <p className="font-medium text-red-500 mt-1 text-sm">{error}</p> : null}
      </div>
    </div>
  );
}
